import React, { useState } from 'react'
import { Drawer, Table } from 'antd'
import EditUserPhoneModal, { IUserWithoutPhone } from './EditUserPhoneModal'

type Props = {
	open: boolean
	onClose: () => void
	users: IUserWithoutPhone[]
	onRefresh: () => void
}

function renderPhone(v: string | null) {
	return v || <span style={{ color: '#9ca3af' }}>-</span>
}

const UsersWithoutPhoneDrawer = ({
	open, onClose, users, onRefresh
}: Props) => {
	const [selectedUser, setSelectedUser] = useState<IUserWithoutPhone | null>(null)

	const columns = [
		{
			title: 'Meno',
			key: 'name',
			render: (_: any, record: IUserWithoutPhone) => `${record.firstName || ''} ${record.lastName || ''}`.trim() || '-'
		},
		{
			title: 'Organizácia',
			dataIndex: 'organizationName',
			render: (v: string | null) => v || '-'
		},
		{
			title: 'Telefón',
			dataIndex: 'phone',
			render: renderPhone
		}
	]

	return (
		<>
			<Drawer
				title="Zákazníci bez telefónneho čísla"
				width={640}
				visible={open}
				onClose={onClose}
				destroyOnClose
			>
				<Table
					rowKey="id"
					dataSource={users}
					columns={columns}
					pagination={false}
					size="small"
					onRow={(record) => ({
						onClick: () => setSelectedUser(record),
						style: { cursor: 'pointer' }
					})}
				/>
			</Drawer>
			<EditUserPhoneModal
				user={selectedUser}
				onClose={() => setSelectedUser(null)}
				onSaved={onRefresh}
			/>
		</>
	)
}

export default UsersWithoutPhoneDrawer
